import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: 'stay',
    message: '',
  });

  const [status, setStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus(null);

    // TODO: replace with your API call
    try {
      await new Promise((resolve) => setTimeout(resolve, 1500));
      setStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        interest: 'stay',
        message: '',
      });
    } catch (error) {
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="luxury-contact">
      {/* Hero Section */}
      <section className="luxury-contact__hero">
        <div className="luxury-contact__hero-overlay" />
        <div className="luxury-contact__hero-content">
          <span className="luxury-contact__eyebrow">GET IN TOUCH</span>
          <h1 className="luxury-contact__hero-title">
            Let&apos;s craft your <br />
            <span>mountain escape.</span>
          </h1>
          <p className="luxury-contact__hero-subtitle">
            Whether you&apos;re planning a serene weekend retreat, a private event,
            or exploring ownership opportunities — our concierge is here to design
            every detail around you.
          </p>
        </div>
        <div className="luxury-contact__scroll-indicator">
          <span>Scroll to connect</span>
          <svg width="16" height="24" viewBox="0 0 16 24" fill="none">
            <path
              d="M8 2V22M8 22L2 16M8 22L14 16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </section>

      {/* Main Content Grid */}
      <section className="luxury-contact__main">
        <div className="luxury-contact__container">
          {/* Left: Story + Info */}
          <div className="luxury-contact__info">
            <div className="luxury-contact__card luxury-contact__card--primary">
              <h2>Your gateway to slow living.</h2>
              <p>
                Globstay is more than a destination — it&apos;s a curated rhythm.
                Nestled in the Himalayan foothills, our estate offers private
                villas, forest domes, and 360-degree valley views designed for
                rest, focus, and meaningful gatherings.
              </p>
              <p>
                Share your vision with us and we&apos;ll respond within one
                business day with a personalised itinerary, pricing, and
                viewing options.
              </p>
            </div>

            <div className="luxury-contact__card">
              <h3>Direct lines</h3>
              <ul className="luxury-contact__details">
                <li>
                  <span className="luxury-contact__label">Concierge</span>
                  <a href="tel:+919999739944">+91 99997 39944</a>
                </li>
                <li>
                  <span className="luxury-contact__label">Email</span>
                  <a href="mailto:info@globstay.com">info@globstay.com</a>
                </li>
                <li>
                  <span className="luxury-contact__label">WhatsApp</span>
                  <a
                    href="https://wa.me/919999739944"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Message us instantly
                  </a>
                </li>
              </ul>
            </div>

            <div className="luxury-contact__card">
              <h3>Visit us</h3>
              <div className="luxury-contact__location">
                <div>
                  <strong>Retreat Location</strong>
                  <p>
                    JP9C+7WM, Almora - Barechhina Rd
                    <br />
                    Sirar, Petshal, Uttarakhand 263601
                  </p>
                </div>
                <div>
                  <strong>Office</strong>
                  <p>
                    Assotech Business Cresterra, Tower-1
                    <br />
                    Office 705, 7th Floor, Noida, UP 201304
                  </p>
                </div>
              </div>
            </div>

            <div className="luxury-contact__features">
              <div className="luxury-contact__feature-pill">
                <span className="luxury-contact__feature-icon">✓</span>
                <span>Private estate tours</span>
              </div>
              <div className="luxury-contact__feature-pill">
                <span className="luxury-contact__feature-icon">✓</span>
                <span>24-hour concierge</span>
              </div>
              <div className="luxury-contact__feature-pill">
                <span className="luxury-contact__feature-icon">✓</span>
                <span>Bespoke itineraries</span>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="luxury-contact__form-wrapper">
            <form className="luxury-contact__form" onSubmit={handleSubmit}>
              <div className="luxury-contact__form-header">
                <h2>Start a conversation</h2>
                <p>
                  Tell us how we can host you — every stay is designed around
                  your needs.
                </p>
              </div>

              <div className="luxury-contact__form-group">
                <label htmlFor="name">Full name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                />
              </div>

              <div className="luxury-contact__form-row">
                <div className="luxury-contact__form-group">
                  <label htmlFor="email">Email address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    required
                  />
                </div>

                <div className="luxury-contact__form-group">
                  <label htmlFor="phone">Phone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 "
                  />
                </div>
              </div>

              <div className="luxury-contact__form-group">
                <label htmlFor="interest">I&apos;m interested in</label>
                <select
                  id="interest"
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                >
                  <option value="stay">Planning a stay</option>
                  <option value="event">Private event or retreat</option>
                  <option value="investment">Ownership &amp; investment</option>
                  <option value="partnership">Partnership opportunities</option>
                  <option value="general">General inquiry</option>
                </select>
              </div>

              <div className="luxury-contact__form-group">
                <label htmlFor="message">Tell us more</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  placeholder="Share your dates, group size, special requests, or any questions..."
                  required
                />
              </div>

              <button
                type="submit"
                className="luxury-contact__submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send enquiry'}
              </button>

              {status === 'success' && (
                <p className="luxury-contact__status luxury-contact__status--success">
                  ✓ Thank you! We&apos;ll respond within 24 hours.
                </p>
              )}
              {status === 'error' && (
                <p className="luxury-contact__status luxury-contact__status--error">
                  Something went wrong. Please try again or email us directly.
                </p>
              )}
            </form>

            <p className="luxury-contact__form-note">
              By submitting, you agree to receive updates about stays, events,
              and ownership via email, phone, or WhatsApp.
            </p>
          </div>
        </div>
      </section>

      {/* Map Section – full width */}
      <section className="luxury-contact__map-section">
        <div className="luxury-contact__map-content">
          <h2>Find us in the hills</h2>
          <p>
            Nestled between pine forests and valley vistas, a scenic drive from
            Almora in Uttarakhand.
          </p>
        </div>
        <div className="luxury-contact__map">
          <iframe
            title="Globstay Location"
            src="https://www.google.com/maps?q=JP9C%2B7WM%20Almora%20Barechhina%20Rd%20Sirar%20Petshal%20Uttarakhand%20263601&output=embed"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

      {/* Footer – full width */}
      <footer className="luxury-contact__footer">
        <div className="luxury-contact__footer-inner">
          <div className="luxury-contact__footer-brand">
            <h3>Globstay</h3>
            <p>
              Slow-living stays in the Himalayan foothills, crafted for
              unhurried moments.
            </p>
          </div>

          <div className="luxury-contact__footer-links">
            <a href="/">Home</a>
            <a href="/experiences">Experiences</a>
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
          </div>

          <div className="luxury-contact__footer-meta">
            <span>
              © {new Date().getFullYear()} Globstay Pvt. Ltd.
            </span>
            <span>All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactUs;
